/*
 * @Date: 2020-03-11 10:25:20
 * @LastEditors: yuanjianlong
 * @LastEditTime: 2025-10-10 15:41:27
 * @FilePath: /st-teacher-2020/src/views/index/router/index.ts
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import { beforeEach, afterEach } from '../../router-hooks';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/history',
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('../pages/index/index.vue'),
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../pages/history/index.vue'),
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../pages/search/index.vue'),
  },
  {
    path: '/customLesson',
    name: 'CustomLesson',
    component: () => import('../../../components-business/custom-lectures-dialog.vue'),
  },
  {
    path: '/lessonData',
    name: 'LessonData',
    component: () => import('../pages/lessonData/index.vue'),
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);
router.afterEach(afterEach);

export default router;
